import screenfull from 'screenfull'

function attachAnalyticsToOpenseaDragon(viewer, metadata, customerCode, firstViewer) {
  let meta = Object.assign({}, metadata)
  meta.action = 'view_item'
  meta.customerCode = customerCode
  viewer.addHandler('open', genericActionEventToAnalytics, meta)

  meta = Object.assign({}, meta)
  meta.action = 'zoom_nobutton'
  viewer.addHandler('canvas-pinch', genericActionEventToAnalytics, meta)
  viewer.addHandler('canvas-scroll', genericActionEventToAnalytics, meta)

  meta = Object.assign({}, meta)
  meta.action = 'pan_nobutton'
  viewer.addHandler('canvas-drag-end', genericActionEventToAnalytics, meta)

  if (firstViewer) {
    meta = Object.assign({}, meta)
    meta.action = 'navigator_usage'
    viewer.addHandler('navigator-click', genericActionEventToAnalytics, meta)

    meta = Object.assign({}, meta)
    meta.action = 'zoom_button'
    viewer.zoomInButton != null ? viewer.zoomInButton.addHandler('click', genericActionEventToAnalytics, meta) : ''
    viewer.zoomOutButton != null ? viewer.zoomOutButton.addHandler('click', genericActionEventToAnalytics, meta) : ''

    meta = Object.assign({}, meta)
    meta.action = 'center_button'
    if (viewer.homeButton) {
      viewer.homeButton.addHandler('click', genericActionEventToAnalytics, meta)
    }

    meta = Object.assign({}, meta)
    meta.action = 'rotate_button'
    if (viewer.rotateRightButton) {
      viewer.rotateRightButton.addHandler('click', genericActionEventToAnalytics, meta)
    }
  }
}

function attachAnalyticsToCustomButton(element, buttonName, metadata, customerCode) {
  if (element == null) {
    console.warn('Tried to attach google analytics to a null element', buttonName)
    return
  }

  let meta = Object.assign({}, metadata)
  meta.customerCode = customerCode
  meta.action = buttonName + '_button'
  element.addEventListener('click', function (event) {
    event.userData = meta
    genericActionEventToAnalytics(event)
  })
}

function genericActionEventToAnalytics(event) {
  const maxEventSendFrequencyMs = 1500
  const eventsTimeouts = {}

  let metadata = event.userData

  if (eventsTimeouts[metadata.action] === undefined) {
    eventsTimeouts[metadata.action] = new Date().getTime() - maxEventSendFrequencyMs - 50
  }

  let now = new Date().getTime()
  let tooFrequent = new Date().getTime() - eventsTimeouts[metadata.action] < maxEventSendFrequencyMs

  if (!tooFrequent) {
    gtag('event', metadata.action, {
      event_category: metadata.customerCode,
      event_label: metadata.author + ' ~ ' + metadata.title + ' ~ ' + metadata.uuid
    })
    eventsTimeouts[metadata.action] = now
  }
}

function setupMultiViewButtons(data, analyticsCustomerCode) {
  if (!window.ganalytisOnToolbarAlreadyCalled) {
    const modeContainerButton = document.getElementById('mode-container')
    if (modeContainerButton) {
      attachAnalyticsToCustomButton(
        modeContainerButton,
        'mode-container',
        data.metadataForGAnalytics[data.viewerId],
        analyticsCustomerCode
      )
    }

    const modeSplitIconButton = document.getElementById('mode-split')
    if (modeSplitIconButton) {
      attachAnalyticsToCustomButton(
        modeSplitIconButton,
        'mode-split',
        data.metadataForGAnalytics[data.viewerId],
        analyticsCustomerCode
      )
    }

    const modeLayersButton = document.getElementById('mode-layers')
    if (modeLayersButton) {
      attachAnalyticsToCustomButton(
        modeLayersButton,
        'mode-layer',
        data.metadataForGAnalytics[data.viewerId],
        analyticsCustomerCode
      )
    }
  }
  window.ganalytisOnToolbarAlreadyCalled = true
}

export default {
  setupAnalyticsCustomButtons: function (data, analyticsCustomerCode) {
    const fullScreenButton = document.getElementById('full-page')
    if (fullScreenButton && screenfull.isEnabled) {
      attachAnalyticsToCustomButton(
        fullScreenButton,
        'fullscreen',
        data.metadataForGAnalytics[data.viewerId || 'viewer0'],
        analyticsCustomerCode
      )
    }

    attachAnalyticsToCustomButton(
      document.getElementById('navigator'),
      'navigator',
      data.metadataForGAnalytics[data.viewerId],
      analyticsCustomerCode
    )
    attachAnalyticsToCustomButton(
      document.getElementById('ruler'),
      'ruler',
      data.metadataForGAnalytics[data.viewerId],
      analyticsCustomerCode
    )
    attachAnalyticsToCustomButton(
      document.getElementById(`logoContainer`),
      'hd-website-link',
      data.metadataForGAnalytics[data.viewerId],
      analyticsCustomerCode
    )
    setupMultiViewButtons(data, analyticsCustomerCode)
  },

  setupAnalyticsForOpenSeaDragon: function (viewer, data, analyticsCustomerCode, firstViewer) {
    attachAnalyticsToOpenseaDragon(
      viewer,
      data.metadataForGAnalytics[data.viewerId],
      analyticsCustomerCode,
      firstViewer
    )
  }
}
